import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable, map } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class RefreshTokenService {
    constructor(private http: HttpClient) {}

    refreshToken(currentToken: string): Observable<any> {
        const refreshTokenUrl = `${environment.baseURL}/refreshToken`;

        // Add your apiKey and Tier as headers
        const headers = new HttpHeaders({
            // eslint-disable-next-line @typescript-eslint/naming-convention
            'Content-Type': 'application/json',
            'apiKey': environment.apiKey,
            'Tier': localStorage.getItem('Tier')
        });

        // Prepare the request body with the current token
        const requestBody = { token: currentToken };

        return this.http.put<{ newToken: string }>(refreshTokenUrl, requestBody, { headers }).pipe(
            map(response => response)
        );
    }
}

 

 

 

 

 